<template>
    <section class="solutionPage" data-subTopAni>
        <div class="topArea" data-aniDelay-basic="5">
            <h2 class="contentSize-padding"><span data-textAni>재생에너지 전력거래 솔루션</span></h2>
            <div>
                <strong data-textAni>
                    기업을 위한<br>
                    재생에너지<br class="mobile"> 전력거래 솔루션
                </strong>
            </div>
            <div>
                <p data-textAni>
                    <b>RE100 파트너사,</b><br>
                    장기적인 계약 이행을 위한<br class="mobile"> <b>‘기업 안정성’</b>과<br>
                    재생에너지 분야<br class="mobile"> <b>‘전문성’</b>이 중요합니다.
                </p>
            </div>
            <div>
                <ul data-animate-list="bottomToTop">
                    <li>
                        <mark data-textAni data-aniDelay="4">안정성</mark>
                        <p data-textAni data-aniDelay="6">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 177 40" fill="none">
                                <path d="M21.6802 25.1956V9.51861C21.6802 8.46374 21.5014 7.92158 20.9377 7.2893C20.5821 6.83696 20.8182 6.44441 21.2638 6.44441H26.3427V25.1956H21.6802ZM26.8475 31.043V34.45H9.88877C6.2965 34.45 4.87055 33.515 4.87055 30.4708V26.0991C4.87055 25.4969 4.66253 25.0442 4.24621 24.5318C3.89052 24.0795 4.12813 23.6584 4.54446 23.6584H9.59198V29.8386C9.59198 30.7718 9.88877 31.043 10.8099 31.043H26.8475ZM7.30583 9.97095C7.30583 8.97616 7.24693 8.434 6.68149 7.80172C6.3258 7.34909 6.56341 6.92678 6.97973 6.92678H12.1175V10.9357C12.1175 14.8851 15.9195 17.2072 19.3644 18.3819L18.0861 20.8239C17.7011 21.5474 16.2459 21.2762 13.6908 19.6777C12.2356 18.7745 10.8392 17.5683 9.91982 16.3022C8.82026 17.8993 7.45495 19.2268 5.88017 20.2814C4.06924 21.4877 1.75175 22.6338 1.36676 21.8785L0 19.2569C3.94971 17.6881 7.30583 15.0663 7.30583 11.2384V9.97095ZM50.5762 25.6176V9.5195C50.5762 8.46462 50.4271 7.98224 49.8634 7.28872C49.4767 6.83608 49.7143 6.44352 50.1602 6.44352H55.2387V13.5585H58.6247V16.9654H55.2387V25.6176H50.5762ZM38.8455 19.5587C40.894 19.5587 42.082 17.9602 42.082 16.0307C42.082 13.9811 40.894 12.4141 38.8455 12.4141C36.7659 12.4141 35.6071 13.9811 35.6071 16.0307C35.6071 17.9602 36.7659 19.5587 38.8455 19.5587ZM55.5962 31.0439V34.4509H38.9339C35.3399 34.4509 33.9157 33.5159 33.9157 30.47V27.3059C33.9157 26.7022 33.7077 26.2496 33.2914 25.7372C32.9357 25.2848 33.1733 24.864 33.5896 24.864H38.6374V29.838C38.6374 30.7727 38.9339 31.0439 39.8551 31.0439H55.5962ZM36.6774 8.6743C36.6774 7.61972 36.6182 7.13735 36.053 6.44352C35.6678 5.99118 35.9054 5.6001 36.351 5.6001H41.4284V8.97704H48.1705V12.2927H45.0517C45.9729 13.3488 46.538 14.6448 46.538 16.1818C46.538 19.9799 43.7752 22.8744 38.8455 22.8744C33.9453 22.8744 31.1526 19.9799 31.1526 16.1818C31.1526 14.6133 31.6885 13.3173 32.5786 12.2927H29.4615V8.97704H36.6774V8.6743ZM79.6954 31.402V26.067H67.3699V30.5286C67.3699 31.1608 67.6385 31.402 68.3203 31.402H79.6954ZM62.7973 25.3717C62.7973 24.7695 62.5892 24.3171 62.1729 23.8047C61.8172 23.3521 62.0548 22.9313 62.4697 22.9313H83.5862C84.0614 22.9313 84.2694 23.0826 84.2694 23.595V34.5976H66.0637C63.9856 34.5976 62.7973 33.3315 62.7973 31.4618V25.3717ZM79.725 10.9637C79.7545 10.5411 79.5169 10.3299 79.0121 10.3299H63.0056V7.04282H80.497C83.8238 7.04282 84.5662 7.94779 84.299 10.8724L83.7336 16.9009H87.7439V20.2181H59.4411V16.9009H79.1908L79.725 10.9637ZM103.297 23.7449C104.663 23.7449 105.941 23.8348 107.098 23.9861V21.8151H99.4657V23.9861C100.624 23.8348 101.901 23.7449 103.297 23.7449ZM109.592 11.4764C109.592 9.78778 107.634 9.03417 103.297 9.03417C98.9608 9.03417 97.0008 9.78778 97.0008 11.4764C97.0008 13.1647 98.9608 13.9169 103.297 13.9169C107.634 13.9169 109.592 13.1647 109.592 11.4764ZM109.83 29.4725C109.83 27.6941 107.575 26.9705 103.297 26.9705C99.0215 26.9705 96.7649 27.6941 96.7649 29.4725C96.7649 31.2524 99.0215 31.9745 103.297 31.9745C107.575 31.9745 109.83 31.2524 109.83 29.4725ZM114.166 11.4764C114.166 14.8215 110.87 17.0823 103.297 17.0823C95.7242 17.0823 92.4267 14.8215 92.4267 11.4764C92.4267 8.1292 95.7242 5.86838 103.297 5.86838C110.87 5.86838 114.166 8.1292 114.166 11.4764ZM114.404 29.4725C114.404 33.1207 110.307 35.2001 103.297 35.2001C96.2879 35.2001 92.1909 33.1207 92.1909 29.4725C92.1909 27.6941 93.1692 26.2767 95.0114 25.2819H94.9227V21.8151H89.131V18.5595H117.434V21.8151H111.642V25.2819H111.554C113.394 26.2767 114.404 27.6941 114.404 29.4725ZM138.799 12.1723C138.827 11.5998 138.621 11.3586 138.027 11.3586H122.108V7.92187H138.621C142.69 7.92187 143.668 8.91667 143.521 12.6847L142.66 28.721H147.113V32.1595H118.812V28.721H138.027L138.799 12.1723ZM156.991 31.435H168.901V29.6866H156.279V30.7129C156.279 31.2854 156.516 31.435 156.991 31.435ZM168.603 10.9369V9.5195H151.913V6.59519H172.464C172.939 6.59519 173.147 6.74656 173.147 7.25897V13.7699H156.516V14.6749C156.516 15.1573 156.695 15.2471 157.141 15.2471H173.534V18.1717H154.646C152.596 18.1717 151.972 17.4481 151.972 15.6382V14.0111C151.972 13.0163 151.765 12.5039 151.2 11.8103C150.844 11.328 151.052 10.9369 151.497 10.9369H168.603ZM151.705 26.5824C151.705 25.9787 151.497 25.5278 151.082 25.0154C150.725 24.563 150.964 24.1404 151.378 24.1404H156.279V26.6109H168.901V24.1404H173.473V34.6008H154.971C152.893 34.6008 151.705 33.3348 151.705 31.4651V26.5824ZM176.8 19.6188V22.8146H165.069V25.4963H160.258V22.8146H148.497V19.6188H176.8Z" fill="#0046FF"/>
                            </svg>과<br>
                            재생에너지를 위한 펀드 설정
                        </p>
                        <p data-textAni data-aniDelay="11">
                            재무 건전성에 기반한<br>
                            안정적인 장기계약 서비스 제공
                        </p>
                    </li>
                    <li>
                        <mark data-textAni data-aniDelay="4">전문성</mark>
                        <p data-textAni data-aniDelay="6">
                            글로벌 친환경 에너지<br>
                            솔루션을 제공하는
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 124 40" fill="none">
                                <path d="M118.937 6.62207C119.929 6.62207 120.441 7.13407 120.441 8.09407V14.0461H102.489V14.5261C102.489 15.1021 103.001 15.3901 104.057 15.3901H120.729V18.4301H102.905C99.4811 18.4301 97.7851 17.1821 97.7851 14.6541V11.0061H115.737V9.69407H97.7851V6.62207H118.937ZM94.9371 19.7741H123.897V23.0061H111.801V25.6941H107.001V23.0061H94.9371V19.7741ZM103.001 24.0941V26.5581H115.865V24.0941H120.569V34.5581H103.065C99.8651 34.5581 98.2971 33.1501 98.2971 30.2701V24.0941H103.001ZM103.001 29.5981V29.9181C103.001 30.9421 103.481 31.4541 104.473 31.4541H115.865V29.5981H103.001Z" fill="#F37321"/>
                                <path d="M83.7601 7.32812C87.0881 7.32812 88.7841 8.99212 88.7841 12.3201V25.6001H84.0481V13.3441C84.0481 11.8081 83.2481 11.0081 81.6801 11.0081H66.0961V7.32812H83.7601ZM92.2721 31.7761H63.3121V28.0321H92.2721V31.7761Z" fill="#F37321"/>
                                <path d="M36.5511 5.91895H46.2791V9.15095H36.5511V5.91895ZM50.4071 13.1189H32.2951V9.91895H50.4071V13.1189ZM39.0791 24.9589C37.6711 24.7029 36.5191 24.2229 35.6231 23.4869C34.2151 22.3989 33.5431 21.0869 33.5431 19.4869C33.5431 17.8869 34.2471 16.5429 35.6871 15.4229C37.0951 14.3349 38.9831 13.7909 41.3511 13.7909C43.7191 13.7909 45.6071 14.3349 47.0471 15.4229C48.4551 16.5429 49.1591 17.8869 49.1591 19.4869C49.1591 21.0869 48.4551 22.3989 47.0791 23.4869C46.1831 24.1909 45.0951 24.6709 43.8151 24.9269V27.4869H47.6871C51.1431 27.4869 52.9031 26.1109 52.9351 23.2949V6.49495H57.6391V15.8069H61.6071V19.2949H57.6391V34.6229H52.9351V29.7269C51.9431 30.5269 50.4071 30.9109 48.3591 30.9109H31.6871V27.4869H39.0791V24.9589ZM41.3511 22.1429C42.2151 22.1429 42.9831 21.9189 43.6231 21.4069C44.2311 20.9269 44.5511 20.2869 44.5511 19.4869C44.5511 18.7189 44.2311 18.0469 43.6231 17.5349C42.9831 17.0549 42.2151 16.7989 41.3511 16.7989C40.4551 16.7989 39.7191 17.0549 39.1111 17.5349C38.4711 18.0469 38.1511 18.7189 38.1511 19.4869C38.1511 20.2869 38.4711 20.9269 39.1111 21.4069C39.7191 21.9189 40.4551 22.1429 41.3511 22.1429Z" fill="#F37321"/>
                                <path d="M4.63805 5.91895H14.366V9.15095H4.63805V5.91895ZM18.558 13.1189H0.446045V9.91895H18.558V13.1189ZM9.50205 25.1509C7.13405 25.1509 5.24605 24.6069 3.83805 23.5189C2.39805 22.4309 1.69405 21.0869 1.69405 19.4869C1.69405 17.8869 2.39805 16.5429 3.83805 15.4229C5.24605 14.3349 7.13405 13.7909 9.50205 13.7909C11.87 13.7909 13.758 14.3349 15.198 15.4229C16.606 16.5429 17.31 17.8869 17.31 19.4869C17.31 21.0869 16.606 22.4309 15.198 23.5189C13.758 24.6069 11.87 25.1509 9.50205 25.1509ZM9.50205 22.1429C10.366 22.1429 11.134 21.9189 11.774 21.4069C12.382 20.9269 12.702 20.2869 12.702 19.4869C12.702 18.7189 12.382 18.0469 11.774 17.5349C11.134 17.0549 10.366 16.7989 9.50205 16.7989C8.60605 16.7989 7.87005 17.0549 7.26205 17.5349C6.62205 18.0469 6.30205 18.7189 6.30205 19.4869C6.30205 20.2869 6.62205 20.9269 7.26205 21.4069C7.87005 21.9189 8.60605 22.1429 9.50205 22.1429ZM26.014 13.5349H29.982V17.1829H26.014V26.8789H21.31V6.49495H26.014V13.5349ZM11.262 31.1669H26.142V34.5589H9.66205C6.07805 34.5589 4.31805 32.8949 4.31805 29.5349V26.2389H9.05405V28.8949C9.05405 30.4309 9.79005 31.1669 11.262 31.1669Z" fill="#F37321"/>
                            </svg>
                        </p>
                        <p data-textAni data-aniDelay="11">
                            재생에너지 전문성으로<br>
                            기업별 전력 분석, 이행 방안 제시
                        </p>
                    </li>
                </ul>
            </div>
        </div>

        <div data-scrollPosition="50">
            <div class="content-process contentSize-padding">
                <p class="subTitle" data-textAni>
                    재생에너지 전력거래<br class="mobile"> 전문 기업 <b class="font-hanwha">테라와트아워</b>가<br>
                    최적의 솔루션을 제안합니다.
                </p>
                <b class="case01" data-textAni data-aniDelay="4">
                    전력거래 솔루션 프로세스
                </b>
                <ul data-animate-list="bottomToTop" data-aniDelay="6">
                    <li>
                        <strong>문의 접수</strong>
                    </li>
                    <li>
                        <strong>
                            전력 수요 예측<br>
                            & 기술 검토
                        </strong>
                        <p>
                            사업장 전력량 및<br>
                            사용 패턴 분석
                        </p>
                    </li>
                    <li>
                        <strong>
                            재생에너지<br>
                            포트폴리오 제안
                        </strong>
                        <p>
                            직접 PPA<br>
                            제3자간 PPA<br>
                            V.PPA
                        </p>
                    </li>
                    <li>
                        <strong>
                            재생E 조달<br>
                            및 이행
                        </strong>
                        <p>발전 자원 조달</p>
                    </li>
                    <li>
                        <strong>관리, 운영</strong>
                        <p>
                            RE100 이행 관리<br>
                            정기 리포트
                        </p>
                    </li>
                </ul>
            </div>
        </div>

        <div class="PPAArea">
            <ul class="tab-btn" data-animate="bottomToTop" data-scrollPosition="70">
                <li><button class="active">직접 PPA</button></li>
                <li><button>제3자간 PPA</button></li>
                <li><button>V.PPA</button></li>
            </ul>
            <div class="PPA01Area content-img contentSize-padding">
                <strong class="subTitle" data-textAni data-scrollPosition="70">직접 PPA</strong>
                <p class="subTitle2" data-textAni data-scrollPosition="70">
                    재생에너지전기공급사업자를 통해<br>
                    발전사업자와 전기사용자가<br class="mobile"> 전력을 직거래하는 계약 방식
                </p>
                <div class="hashArea" data-animate-list="bottomToTop" data-aniDelay="4" data-scrollPosition="70">
                    <b>장기적으로 안정적인 재생에너지 조달을 희망하는 기업</b>
                    <b>#전력 다소비 기업</b>
                    <b>#낮 시간대 전력 소비가 많은 기업</b>
                </div>
                <div class="box-img" data-animate="bottomToTop" data-scrollPosition="70">직접 PPA 이미지</div>
               <!--  <dl data-animate-list="bottomToTop" data-scrollPosition="70">
                    <dt>*직접PPA</dt>
                    <dd>
                        재생에너지를 이용하여 생산된 전기를 전력시장을 통하지 않고<br>
                        재생에너지전기공급사업자를 통해 전기사용자에게 직접 공급하는 제도
                    </dd>
                </dl> -->
            </div>
            
            <div class="PPA02Area content-img contentSize-padding">
                <strong class="subTitle" data-textAni data-scrollPosition="70">제3자간 PPA</strong>
                <p class="subTitle2" data-textAni data-scrollPosition="70">
                    발전사업자와 한국전력,<br class="mobile"> 한국전력과 전기사용자가<br>
                    각각 계약을 체결하는 방식
                </p>
                <div class="hashArea" data-animate-list="bottomToTop" data-aniDelay="4" data-scrollPosition="70">
                    <b>#장기적으로 안정적인 재생에너지 조달을 희망하는 기업</b>
                    <b>#전력소비량이 상대적으로 적은 기업</b>
                    <b>#24시간 조업 기업</b>
                </div>
                <div class="box-img" data-animate="bottomToTop" data-scrollPosition="70">제3자 PPA 이미지</div>
            </div>

            <div class="PPA03Area content-img contentSize-padding">
                <strong class="subTitle" data-textAni data-scrollPosition="70">V.PPA</strong>
                <p class="subTitle2" data-textAni data-scrollPosition="70">
                    전력거래 당사자간<br class="mobile"> 합의된 고정가격(SMP+REC)과<br>
                    도매전력가격(SMP)<br class="mobile"> 차액 정산을 통한 REC 거래
                </p>
                <div class="hashArea" data-animate-list="bottomToTop" data-aniDelay="4" data-scrollPosition="70">
                    <b>#RE100 단기 이행이 필요한 기업</b>
                    <b>#안정적인 REC 조달을 희망하는 기업</b>
                </div>
                <div class="box-img" data-animate="bottomToTop" data-scrollPosition="70">PPA 이미지</div>
            </diV>
        </div>
        

        <div>
            <div class="expertArea contentSize-padding" data-scrollPosition="50">
                <p class="subTitle" data-textAni>
                    <b>20년 장기계약 PPA,</b><br>
                    안정적인 자원 조달이 가능한<br class="mobile"> <b class="font-hanwha">테라와트아워</b>와 함께하세요.
                </p>
                <ul data-animate-list="rightToLeft" data-scrollPosition="70" data-aniDelay="4">
                    <li>
                        <div>
                            글로벌 태양광 시장을<br>
                            선도하는 <span class="font-hanwha">한화그룹</span> 경쟁력
                        </div>
                    </li>
                    <li>
                        사업개발, EPC, O&M<br>
                        다운스트림 전 영역의<br>
                        밸류체인 보유
                    </li>
                    <li>
                        <div>
                            글로벌 태양광 발전소<br>
                            1GW 관리 · 운영 경험의<br>
                            <span class="font-hanwha">한화컨버전스</span>
                        </div>
                    </li>
                </ul>
            </div>
        </div>

        <div class="contentSize-padding" data-scrollPosition="70">
            <p class="inquiryTitle">
                RE100 이행,<br>
                <b>지금 바로 문의하세요!</b>
            </p>
            <form>
                <fieldset class="content-inquiry">
                    <ul>
                        <li>
                            <label for="company">기업명</label>
                            <div>
                                <input type="text" id="company" name="company" @input="onChange" required>
                            </div>
                        </li>
                        <li>
                            <label for="name">담당자명</label>
                            <div>
                                <input type="text" id="name" name="name" @input="onChange" required>
                            </div>
                        </li>
                        <li>
                            <label for="phonenum">전화번호</label>
                            <div>
                                <input type="text" id="phonenum" name="phonenum" @input="onChange" data-formet="number" maxlength="11" required>
                            </div>
                        </li>
                        <li>
                            <label for="email">이메일</label>
                            <div>
                                <input type="text" id="email" name="email"  @input="onChange" required>
                            </div>
                        </li>
                        <li>
                            <label for="implementgoal">RE100 이행목표</label>
                            <div>
                                <input type="text" name="implementgoal" id="implementgoal" placeholder="예시 : 2050년까지 100% 재생에너지 전환" @input="onChange">
                            </div>
                        </li>
                        <li>
                            <label for="" data-comment="*중복선택 가능">이행 방안</label>
                            <div>
                                <input type="checkbox" id="implementplan-PPA" name="implementplan" value="PPA" @input="onChange">
                                <label for="implementplan-PPA">직접 PPA</label>
                                <input type="checkbox" id="implementplan-REC" name="implementplan" value="REC구매" @input="onChange">
                                <label for="implementplan-REC">제3자간 PPA</label>
                                <input type="checkbox" id="implementplan-sunlight" name="implementplan" value="자가소비형 태양광 구축" @input="onChange">
                                <label for="implementplan-sunlight">V.PPA</label>
                                <input type="checkbox" id="implementplan-inquiry" name="implementplan" value="종합솔류션 문의" @input="onChange">
                                <label for="implementplan-inquiry">종합솔루션 문의</label>
                            </div>
                        </li>
                        <li class="full">
                            <label for="annualusage">연간 전력사용량</label>
                            <div data-unit="GWh">
                                <input type="text" id="annualusage" name="annualusage" placeholder="연간 전력사용량을 작성하세요." @input="onChange" data-formet="number">
                            </div>
                            <small>다수의 사업장이 있을 경우, 각 사업장 별 연간 전력 사용량을 하단 상세 내용에 적어주세요.</small>
                        </li>
                        <li>
                            <label for="content">상세 내용</label>
                            <textarea id="content" name="content" placeholder="기타 문의 및 참고 내용을 작성하세요. (200자 내)" @input="onChange"></textarea>
                        </li>
                    </ul>
                    <inquiry-agree :inputsRequired="inputsRequired" :inputs="inputs"></inquiry-agree>
                    <input type="submit" value="문의하기" class="btn-black" @click.prevent="onSubmit">
                </fieldset>
            </form>
            <modal-alert v-if="isModal" :isModal="isModal" @modalClose="modalClose" :modalText="modalText"/>
        </div>
    </section>
</template>
<script>
import * as api from '../api/api'
import InquiryAgree from '@/components/InquiryAgree.vue';
import ModalAlert from '@/components/modal/ModalAlert.vue';
// import { positionActive } from '../css/style.js'

export default {
    name: 'SolutionPage',
    components: { 
        InquiryAgree,
        ModalAlert
    },
    data() {
        return {
            topClassName: '[data-subTopAni] .topArea',
            topElement: undefined,
            topContents: undefined,
            titleElement: undefined,
            inputsRequired: {},
            inputs: {},
            isModal: false,
            modalText: {
                title: '',
                description: '',
            }
        }
    },
    methods : {
        init(){
            this.topElement = document.querySelector(this.topClassName);
            this.titleElement = document.querySelector(`${this.topClassName} h2`);
            this.topContents = document.querySelectorAll(`${this.topClassName} > div`);
            // 타이틀 초기화
            this.titleElement.classList.remove('active');
            // 서브페이지 탑 애니메이션 초기화
            this.topElement.style.setProperty('--bgY', 0);
            setTimeout(() => {
                this.titleElement.classList.add('active');
            }, 300);
            this.topContents.forEach((element)=>{
                element.classList.remove('active');
                element.classList.remove('ani');
            })
            setTimeout(() => {
                this.topContents.forEach((element)=>{
                    element.classList.add('ani');
                })
            }, 300);

        },
        scrollEvent() {
            const topElement = this.topElement;
            const topContents = this.topContents;
            const headerElement = document.querySelector('header');
            topElement.style.setProperty('--totalContent', topContents.length);
            window.addEventListener('scroll', ()=>{
                const scrollTop = window.scrollY;
                const topElementTop = topElement.offsetTop;
                const topElementHeight = topElement.offsetHeight;
                const headerElementHeight = headerElement.offsetHeight;
                topContents.forEach((_, idx)=>{
                    if(scrollTop > (topElementHeight - window.innerHeight) / topContents.length * idx + headerElementHeight){
                        topContents[idx].classList.add('active');
                    }else{
                        topContents[idx].classList.remove('active');
                    }
                })
                if(scrollTop > topElementTop && scrollTop < topElementHeight + topElementTop){
                    topElement.style.setProperty('--bgY', -((scrollTop - topElementTop) / topElementHeight * 250) + 'px');
                }
            })

            

            window.addEventListener('scroll', this.test)
        },
        test(){
            const scrollTop = window.scrollY;
            const tabListElement = document.querySelectorAll('.PPAArea > .tab-btn li button');
            const tabElementHeight = document.querySelector('.PPAArea > .tab-btn').offsetHeight;
            const headerElementHeight = document.querySelector('header').offsetHeight;
            const PPAElement = document.querySelectorAll('.PPA01Area, .PPA02Area, .PPA03Area');
            PPAElement.forEach((element, idx)=>{
                const test = element.parentNode.classList.contains('PPAArea') ? document.querySelector('.PPAArea').offsetTop : 0;
                if(scrollTop > element.offsetTop - tabElementHeight - headerElementHeight + test - 10){
                    tabListElement.forEach((tabList)=>{
                        tabList.classList.remove('active');
                    })
                    tabListElement.item(idx).classList.add('active');
                }else{
                    tabListElement.item(idx).classList.remove('active');
                }
            })
            if(scrollTop < document.querySelector('.PPAArea').offsetTop){
                tabListElement.item(0).classList.add('active');
            }
        },
        tabClick(){
            const tabElementHeight = document.querySelector('.PPAArea > .tab-btn').offsetHeight;
            const headerElement = document.querySelector('header');
            const headerElementHeight = headerElement.offsetHeight;
            const tabBtn = document.querySelectorAll('.PPAArea > .tab-btn li button')
            const PPAElement = document.querySelectorAll('.PPA01Area, .PPA02Area, .PPA03Area');
            tabBtn.forEach((btnElement, idx)=>{
                btnElement.addEventListener('click',()=>{
                    let offsetTop = PPAElement.item(idx).offsetTop - tabElementHeight - headerElementHeight;
                    PPAElement.item(idx).parentNode.classList.contains('PPAArea') && (offsetTop += document.querySelector('.PPAArea').offsetTop);
                    window.scrollTo({top: offsetTop,behavior: "smooth"});
                })
            })
        },
        onSubmit(){
            if(!api.isRequired(this.inputsRequired)){
                api.user('inquiry', {...this.inputsRequired, ...this.inputs, consultpurpose: 'RE100'})
                    .then((result)=>{
                        if(result.statusCode === '200'){
                            this.modalText['title'] = '문의'
                            this.modalText['description'] = '요청이 완료되었습니다' 
                            this.isModal = true
                            api.dataInit(this.inputsRequired, this.inputs)
                           /*  gtag('event', 'contact_us', {
                                'event_name': 'contact_us'
                            }); */
                            this.$gtag.event('click', {
                                event_category: 'inquiry',
                                event_label: 'solution inquiry',
                                value: 'solution_inquiry',
                            })
                        }
                    })
            }
        },
        onChange(e){
            api.onChange(e, this.inputsRequired, this.inputs)
        },
        modalClose(){
            this.isModal = false;
        }
    },
    mounted() {
        this.init();
        this.scrollEvent();
        this.tabClick();
        // positionActive('add');
        document.querySelectorAll('input[required]').forEach((element)=>{
            element.required && (this.inputsRequired[element.name] = '')
        })

    },
    beforeUnmount(){
        this.init();
        // positionActive('remove');
        window.removeEventListener('scroll',this.test)
    },
}
</script>
<style>
    /* .solutionPage .topArea > div[data-aniType="basic"].active:has( + .active){transform: translateY(-100%);} */
    /* .solutionPage .topArea div:nth-of-type(3) ul li{opacity: 0; transition-duration: var(--aniDutaion); transition-timing-function: ease-in-out;}
    .solutionPage .topArea div:nth-of-type(3).active ul li{opacity: 1; transition-delay: calc(var(--aniIdx) * var(--aniDelay));} */
</style>